import { defineMessages } from 'react-intl';
import type { LocalePerProduct } from 'contracts';

const seo: LocalePerProduct = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.login.seo.livejasmin.title',
      defaultMessage: 'Login',
    },
    description: {
      id: 'pages.login.seo.livejasmin.description',
      defaultMessage: 'Model Center - Login',
    },
  }),
  oranum: defineMessages({
    title: {
      id: 'pages.login.seo.oranum.title',
      defaultMessage: 'Login',
    },
    description: {
      id: 'pages.login.seo.oranum.description',
      defaultMessage: 'Broadcaster Center - Login',
    },
  }),
};

const header: LocalePerProduct = {
  livejasmin: defineMessages({
    title: {
      id: 'pages.login.header.livejasmin.title',
      defaultMessage: 'Log In to Model Center',
    },
    support: {
      id: 'pages.login.header.livejasmin.support',
      defaultMessage: 'Need some help? Get <a>Live Support</a>',
    },
  }),
  oranum: defineMessages({
    title: {
      id: 'pages.login.header.oranum.title',
      defaultMessage: 'Oranum Broadcaster login',
    },
    support: {
      id: 'pages.login.header.oranum.support',
      defaultMessage: 'Need some help? Contact <a>Customer Support</a>',
    },
  }),
};

const footer: LocalePerProduct = {
  livejasmin: defineMessages({
    cta: {
      id: 'pages.login.footer.livejasmin.cta',
      defaultMessage: "Don't have an account?",
    },
    createAccount: {
      id: 'pages.login.footer.livejasmin.createAccount',
      defaultMessage: 'Join us now!',
    },
  }),
  oranum: defineMessages({
    cta: {
      id: 'pages.login.footer.oranum.cta',
      defaultMessage: "Don't have an account?",
    },
    createAccount: {
      id: 'pages.login.footer.oranum.createAccount',
      defaultMessage: 'Join us now!',
    },
  }),
};

const form: LocalePerProduct = {
  livejasmin: defineMessages({
    emailShort: {
      id: 'pages.login.form.livejasmin.emailShort',
      defaultMessage: 'Email',
    },
    passwordShort: {
      id: 'pages.login.form.livejasmin.passwordShort',
      defaultMessage: 'Password',
    },
    login: {
      id: 'pages.login.form.livejasmin.login',
      defaultMessage: 'Login',
    },
    recoverPassword: {
      id: 'pages.login.form.livejasmin.recoverPassword',
      defaultMessage: 'Forgot your password?',
    },
  }),
  oranum: defineMessages({
    emailShort: {
      id: 'pages.login.form.oranum.emailShort',
      defaultMessage: 'Email:',
    },
    passwordShort: {
      id: 'pages.login.form.oranum.passwordShort',
      defaultMessage: 'Password',
    },
    login: {
      id: 'pages.login.form.oranum.login',
      defaultMessage: 'Login',
    },
    recoverPassword: {
      id: 'pages.login.form.oranum.recoverPassword',
      defaultMessage: 'Forgot your password?',
    },
  }),
};

const signup: LocalePerProduct = {
  livejasmin: defineMessages({
    cta: {
      id: 'pages.login.signup.livejasmin.cta',
      defaultMessage: 'Join us!',
    },
  }),
  oranum: defineMessages({
    cta: {
      id: 'pages.login.signup.oranum.cta',
      defaultMessage: 'Join us!',
    },
  }),
};

const error = defineMessages({
  generic: {
    id: 'pages.login.error.generic',
    defaultMessage: 'Something went wrong',
  },
  authentication: {
    id: 'pages.login.error.authentication',
    defaultMessage: 'Invalid email or password',
  },
});

const warning = defineMessages({
  email: {
    id: 'pages.login.warning.email',
    defaultMessage: 'Email address is incorrect. Please try again.',
  },
  password: {
    id: 'pages.login.warning.password',
    defaultMessage: 'Password is required',
  },
});

export default {
  pages: {
    login: {
      seo,
      signup,
      header,
      footer,
      form,
      error,
      warning,
    },
  },
};
